var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-app',{class:{ dark: _vm.dark },attrs:{"params":_vm.f7params}},[(_vm.url)?_c('f7-view',{attrs:{"main":"","url":_vm.url,"iosPageLoadDelay":200}}):_vm._e(),(_vm.gtu)?_c('TermsOfUse'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }